import React, { useState, useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgress from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import CustomSelectNew from "../../../../components/UpdateUi/CustomeSelect";
import ToastModal from "views/components/ToastModal";
import { parseAndSetFlag } from "utils/Utils";

const PacketAllocationHoAllocationCreate = ({
  classes,
  packetAllocationShow,
  packetId,
  setPacketId,
  onClose,
  rawData,
}) => {
  const navigate = useNavigate();
  const [packetNumberFrom, setPacketNumberFrom] = useState("");
  const [packetNumberFromState, setPacketNumberFromState] = useState(false);
  const [packetSize, setPacketSize] = useState("");
  const [packetSizeState, setPacketSizeState] = useState(false);
  const [packetNumberTo, setPacketNumberTo] = useState("");
  const [packetNumberToState, setPacketNumberToState] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [isValid, setIsValid] = useState(true);
  const [packetWeightState, setPacketWeightState]= useState(false);
  const [packetWeight, setPacketWeight]= useState("")
  const [preFixName, setPreFixName]= useState(null);
  const [preFixNameState, setPreFixNameState]= useState(packetWeight ? packetWeight : "")
  const [callInProgress, setCallInProgress] = useState(false);
  const packetSizes = [
    { code: "3.0*3.0", name: "3.0*3.0" },
    { code: "3.0*6.0", name: "3.0*6.0" },
    { code: "6.0*3.0", name: "6.0*3.0" },
    { code: "6.0*6.0", name: "6.0*6.0" },
    { code: "10.0*6.5", name: "10.0*6.5" },
  ];

  const outletData = useOutletContext();
  const removedPacketSize = outletData?.removePacketSizeFlag;
  const packetSizeList = outletData?.packetSizesList ? JSON.parse(outletData?.packetSizesList) : packetSizes;
  const enabledPacketPreFix = parseAndSetFlag(outletData?.enabledPacketPreFix);
  const differeneceBetweenPacketNumbers = outletData?.differeneceBetweenPacketNumbers;
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isValidated = () => {
    if (packetSize === "") {
      setPacketSizeState(true);
    } else {
      setPacketSizeState(false);
    }
    if (packetNumberFrom === "") {
      setPacketNumberFromState(true);
    } else {
      setPacketNumberFromState(false);
    }
    if (packetNumberTo === "") {
      setPacketNumberToState(true);
    } else {
      setPacketNumberToState(false);
    }
    if(packetWeight === ""){
      setPacketWeightState(true);
    }else{
      setPacketWeightState(false)
    }
    if (packetNumberFrom === "" || packetNumberTo === "" || packetSize === "" || packetWeight === "") {
      return false;
    } else {
      return true;
    }
  };
  useEffect(() => {
    if (packetId) {
      GetData();
    }
  }, []);

  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.PACKET_INVENTORY_MASTER_FIND_BY_ID + packetId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setPacketNumberFrom(result?.data?.serialStartNo);
      setPacketNumberTo(result?.data?.serialEndNo);
      setPacketSize(result?.data?.size);
      setPacketWeight(result?.data?.packetWeight);
      setPreFixName(result?.data?.prefix || null);
    }
  };

  const handleCreateSubmit = async (event) => {
    if (isValidated()) {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.PACKET_INVENTORY_MASTER_CREATE,
        method: "POST",
        authToken: authToken,
        data: {
          size: packetSize,
          serialStartNo: parseInt(packetNumberFrom),
          serialEndNo: parseInt(packetNumberTo),
          packetWeight: packetWeight,
          prefix:enabledPacketPreFix ? preFixName : null,
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else {
        onClose("create");
        packetAllocationShow(true);
      }
    }
  };

  const handleEditSubmit = async (event) => {
    if (isValidated()) {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.PACKET_INVENTORY_MASTER_UPDATE + packetId,
        method: "PUT",
        authToken: authToken,
        data: {
          size: packetSize,
          serialStartNo: parseInt(packetNumberFrom),
          serialEndNo: parseInt(packetNumberTo),
          packetWeight: packetWeight,
          prefix:enabledPacketPreFix ? preFixName : null,
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else {
        onClose("update");
        packetAllocationShow(true);
      }
    }
  };
  const handleCancel = () => {
    packetAllocationShow(true);
    setPacketId("");
  };

  const handleInputChange = (e,name) => {
    const enteredValue = e;
    isSerialNumberValid(enteredValue,name);
  };

  const isSerialNumberValid = (enteredValue,name) => {
    if (!enteredValue || isNaN(enteredValue)) {
      // Check if the input is empty or not a number
      return false;
    }

    const enteredNumber = parseFloat(enteredValue);
   
    for (const item of rawData) {
      if (
        enteredNumber >= item.serialStartNo &&
        enteredNumber <= item.serialEndNo - 1 &&
        packetSize === item?.size
      ) {
        if(name==="from"){
          setPacketNumberFrom("")
          setPacketNumberFromState(true);
        }else{
          setPacketNumberTo("")
          setPacketNumberToState(true);
        }
        toastUpdate("Error", "Packet number is Already exists", true);
        setIsValid(true)
        return false;
      }
    }
    if(Number(packetNumberFrom) > Number(packetNumberTo) && packetNumberTo && packetNumberFrom){
      toastUpdate("Error", "packet number from should not be greater than packet number to", true);
      setIsValid(true)
      return false;
    }
    if (
      packetNumberFrom &&
      packetNumberTo &&
      Number(packetNumberTo) - Number(packetNumberFrom) > Number(differeneceBetweenPacketNumbers)
    ) {
      toastUpdate(
        "Error",
        `Difference between Packet Number From and To should not be more than ${differeneceBetweenPacketNumbers}`,
        true
      );
      setPacketNumberTo('');
      setIsValid(true);
      return false;
    }
    setPacketNumberFromState(false);
    setPacketNumberToState(false);
    setIsValid(false)
    return true;
  };
  const handleChange = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setPacketNumberFrom(e);
    }
  };
  const handleChange1 = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setPacketNumberTo(e);
    }
  };
  const handleChange2 = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setPacketWeight(e);
    }
  };
  const handlePacketSize = (e) => {
    setPacketSize(e);
    if(enabledPacketPreFix){ 
      const packetPreFix = packetSizeList?.filter((item) => item.code === e);
      setPreFixName(packetPreFix?.[0]?.prefix || null);
    }
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={
            packetId ? "Edit Packet HO Inventory" : "Create Packet HO Inventory"
          }
          button1=" Save"
          button2=" Cancel"
          button1click={packetId ? handleEditSubmit : handleCreateSubmit}
          button2click={handleCancel}
          disabled1={isValid}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Packet Size"
              error={packetSizeState}
              value={packetSize}
              setState={handlePacketSize}
              data={packetSizeList}
              setError={setPacketSizeState}
            />
          </Grid>
          {enabledPacketPreFix &&
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
               label="Prefix"
               required
               error={preFixNameState}
               id="lp_branch_code"
               value={preFixName || ""}
               setError={setPreFixNameState}
               setState={setPreFixName}
               type="prefix"
               maxLength={4} 
               disabled={true}
            />
          </Grid>
          }
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Packet Number From"
              required
              error={packetNumberFromState}
              id="lp_branch_code"
              value={packetNumberFrom || ""}
              setState={handleChange}
              setError={setPacketNumberFromState}
              setBlur={(e)=>handleInputChange(e,"from")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Packet Number To"
              required
              error={packetNumberToState}
              id="lp_branch_code"
              value={packetNumberTo || ""}
              setError={setPacketNumberToState}
              setState={handleChange1}
              setBlur={(e)=>handleInputChange(e,"to")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Packet Weight"
              required
              error={packetWeightState}
              id="lp_branch_code"
              value={packetWeight || ""}
              setError={setPacketWeightState}
              setState={handleChange2}
              setBlur={()=>setIsValid(false)}
            />
          </Grid>
        </Grid>
      </Grid>
      {callInProgress && <CircularProgress callInProgress={callInProgress} />}
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
    </Grid>
  );
};

PacketAllocationHoAllocationCreate.propTypes = {
  classes: PropTypes.object,
};

export default PacketAllocationHoAllocationCreate;
